import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from './locales/en/common.json';
import pagesEn from './locales/en/pages.json';
import componentsEn from './locales/en/components.json';
import errorsEn from './locales/en/errors.json';
import validationEn from './locales/en/validation.json';
import reviewEn from './locales/en/review.json';
import navigationEn from './locales/en/navigation.json';

import commonAr from './locales/ar/common.json';
import pagesAr from './locales/ar/pages.json';
import componentsAr from './locales/ar/components.json';
import errorsAr from './locales/ar/errors.json';
import validationAr from './locales/ar/validation.json';
import reviewAr from './locales/ar/review.json';
import navigationAr from './locales/ar/navigation.json';

export const resources = {
  en: {
    common: commonEn,
    pages: pagesEn,
    components: componentsEn,
    errors: errorsEn,
    validation: validationEn,
    navigation: navigationEn,
    review: reviewEn,
  },
  ar: {
    common: commonAr,
    pages: pagesAr,
    components: componentsAr,
    errors: errorsAr,
    validation: validationAr,
    navigation: navigationAr,
    review: reviewAr,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },
    resources,
    ns: ['common', 'pages', 'components', 'errors', 'validation', 'navigation', 'review'],
    defaultNS: 'common',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
